module.exports = __webpack_public_path__ + "assets/static/png/dtek.7895c5f52cb842497d50e0efd1c01164.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myElectricity/images/dtek.png
 ** module id = 39
 ** module chunks = 1
 **/